import { FC } from "react";

import "@tennr/style/index.css";
import "./CareersPage.css";

// Universal
import { Link } from "@tanstack/react-router";
import { Button } from "@tennr/frontend/components/Button";
import { MetadataTags } from "@tennr/frontend/components/MetadataTags";
import { PageBackground } from "@tennr/frontend/components/PageBackground";
import { SiteFooter } from "@tennr/frontend/components/SiteFooter";
import { doubleQuote, singleQuote } from "@tennr/frontend/utils";

import { Heading } from "@tennr/frontend/components/Heading";
import { HorizontalMarquee } from "@tennr/frontend/components/HorizontalMarquee";
import { Card } from "@tennr/frontend/components/Card";
import { AshbySection } from "@tennr/frontend/sections/AshbySection/AshbySection";
import { HeroSection } from "@tennr/frontend/sections/HeroSection";
import { TestimonialsSection } from "@tennr/frontend/sections/TestimonialsSection";
import { DeepDiveSection } from "@tennr/frontend/sections/DeepDiveSection";
import { VideoPlayer } from "@tennr/frontend/components/VideoPlayer";
export const CareersPage: FC = () => {
  const pressCards = [
    {
      logoSrc: "/figma/img/award-top-40.png",
      logoAlt: "Intelligent Applications 40",
      awardTitle: "Top 40 Private Companies\n2024",
    },
    {
      logoSrc: "/figma/svg/forbes-logo.svg",
      logoAlt: "Forbes",
      awardTitle: "Cloud 100 Rising Stars\n2024",
    },
    {
      logoSrc: "/figma/img/award-promising-startups.png",
      logoAlt: "The Information",
      awardTitle: "50 Most Promising Startups\n2024",
    },
    {
      logoSrc: "/img/cb-insights-logo.png",
      logoAlt: "CB Insights",
      awardTitle: "CB Insights Digital\nHealth 50 2024",
    },
    {
      logoSrc: "/figma/img/award-top-40.png",
      logoAlt: "Intelligent Applications 40",
      awardTitle: "Top 40 Private Companies\n2024",
    },
    {
      logoSrc: "/figma/svg/forbes-logo.svg",
      logoAlt: "Forbes",
      awardTitle: "Cloud 100 Rising Stars\n2024",
    },
    {
      logoSrc: "/figma/img/award-promising-startups.png",
      logoAlt: "The Information",
      awardTitle: "50 Most Promising Startups\n2024",
    },
    {
      logoSrc: "/img/cb-insights-logo.png",
      logoAlt: "CB Insights",
      awardTitle: "CB Insights Digital\nHealth 50 2024",
    },
    {
      logoSrc: "/figma/img/award-top-40.png",
      logoAlt: "Intelligent Applications 40",
      awardTitle: "Top 40 Private Companies\n2024",
    },
    {
      logoSrc: "/figma/svg/forbes-logo.svg",
      logoAlt: "Forbes",
      awardTitle: "Cloud 100 Rising Stars\n2024",
    },
    {
      logoSrc: "/figma/img/award-promising-startups.png",
      logoAlt: "The Information",
      awardTitle: "50 Most Promising Startups\n2024",
    },
    {
      logoSrc: "/img/cb-insights-logo.png",
      logoAlt: "CB Insights",
      awardTitle: "CB Insights Digital\nHealth 50 2024",
    },
  ];
 
  return (
    <>
      <MetadataTags
        title="Careers | Tennr"
        description="Find and apply for open positions at Tennr. Meet our team, learn about our values, and check out the benefits and growth opportunities we offer."
        imageUrl="https://tennr.com/share_cards/sharecard.png"
      />
      <main className="careers-page">
        <PageBackground bgImage="/img/careers-hero-bg.jpg" bgImageVert="/img/careers-hero-bg-vert.jpg" />
        <HeroSection
          noAnimate={true}
          className="bottom-left"
          cmsContent={{
            heading: {
              title: "Work With Us",
              heading: "Careers at Tennr",
              body: "If you're smart, fast, and not afraid to speak your mind, you'll fit right in. ",
            }            
          }}
        >
          <p>If you’re smart, fast, and not afraid to speak your mind, you’ll fit right in. </p>
          <Link to="https://jobs.ashbyhq.com/tennr">            
            <Button
              text="See Open Roles"
              width={204}
                          
              background="#EEDFD1"
              textFromColor={"#273127"}
              className="hero-cta-button"              
              // Light button will swap to orangey brown on light backgrounds
            />
          </Link>
            
        </HeroSection>
        <section className="life-at-tennr">
          <Heading className="life-heading" {...{ title: "Our Culture",
                heading: "Life at Tennr",
                body: "This is our best impersonation of a corporate HR video.",
                color: "dark",
                variant: "hero",
                position: "left",
                width: 730,
                mobileMaxWidth: 405,}} />
          <VideoPlayer {...{ source: "https://vimeo.com/1094065155", poster: "/video-player-assets/poster.png" }}/>
        </section>
        <section className="who-we-are">
          <Heading className="team-heading"
            title="Who We Are"
            heading="Meet The Team"
            body="Get to know the people behind the most advanced patient processing in healthcare."
          />
          <Link className="about-link" to="/about">
            <Button text="ABOUT US" backgroundColorLight="#9B4E45" backgroundColorDark="#9B4E45" width={138} height={58} textColorLight="#FBFBF9" textColortDark="#FBFBF9" />
          </Link>
          <div className="marquee-wrapper">
            <HorizontalMarquee autoscroll={true} autoscrollSpeed={0.1} widthMode="full" gap={14}>
              {[1, 2, 3, 4, 5, 6, 7].map((n) => (
                <img key={n} src={`/img/meet-the-team/${n}.png`} alt={`Team member ${n}`} />
              ))}
            </HorizontalMarquee>
          </div>
        </section>
        <DeepDiveSection {...{
            heading: {
              heading:"Our Values",
              title:"HOW WE WORK",
              body:"We work hard, encourage strong perspectives, and are maniacally focused on reducing patient delays across the U.S. healthcare system.",
              color:"dark",
              variant:"section",
              width: 560
            },
            backgroundImage: '/img/careers-accordian-bg.png',
            items:[
              {
                title: "Cowboy",
                body:"You set the pace. Do the thing instead of just talking about it.",
                id: "Cowboy",
              },
              {
                title: "Conviction",
                body:"If it’s not a hell yes, it’s a hell no. We have zero interest in doing anything halfway. Whether we’re hiring a candidate, building a client diagram, or even buying team merch, we go all the way. We’re unrelenting (in a good way).",
                id: "Conviction",
              },
              {
                title: "Clarity",
                body:"Everything we do depends on clarity of thought, speech, and writing. Clear communication sets a strong foundation.",
                id: "Clarity",
              },
              {
                title: "Customer (and Problem) Obsessed",
                body:"We live and die by creating value for our customers and solving one of healthcare’s biggest problems. We don’t trust the smiling face or quiet Slack channel. A commercial nose is one that tracks only the scent of business ROI—or the stench of rabid failure to deliver real value. Picking up the scent of failure is even more important than the former.",
                id: "Customer (and Problem) Obsessed",
              },
              {
                title: "Confrontation",
                body:"Failure and real discomfort comes from what we ignore, not what we face head-on. If you believe we are ever on a path towards failure in any part of the business, discuss it with the right person directly and act decisively. We don’t wait.",
                id: "Confrontation",
              },
              {
                title: "Courage",
                body:"Attempting to communicate clearly, confront hard truths and failures, and face reality is a terrifying position for any social being. But everything we’re doing here is a leap of faith. It takes a lot of courage. Here, we want you to nurture it in yourself and encourage it in others.",
                id: "Courage",
              }
            ]
          }
        }/>
        <section className="benefits">
          <Heading  className="benefits-heading" title="The Perks" heading="Benefits & Growth Opportunities" />
          <div className="rich-text">
            <ul>              
              <li>Meaningful equity</li>
              <li>In-person culture</li>
              <li>Competitive salary</li>
              <li>Promoting from within</li>
              <li>401k matching</li>
              <li>Unlimited PTO</li>
              <li>Free lunch*</li>              
            </ul>
            <h6>*And a pantry stocked with a strangely wide array of puffed corn snacks</h6>
          </div>
        </section>
        <section className="open-roles">
          <Heading title="We're Hiring" heading="Open roles" />          
          <AshbySection />            
        </section>
        <section className="employee-testimonials">          
          <TestimonialsSection { ...{
            heading:{
              title:"EMPLOYEE TESTIMONIALS",
              heading:"What It's Like At Tennr"
            },
            testimonials:[
                {
                  quote: doubleQuote(
                    "From the moment I walk in the door to the minute I leave, the team's energy, excitement, and motivation to fix the healthcare system is palpable. I've worked at a bunch of startups, and I can confidently say that every day at Tennr is the best day at any of those other startups."
                  ),
                  image: "/img/chris-holt.png",
                  attributedTo: "Chris Holt",
                  attributedToTitle: "Engineering Manager",
                },
                {
                  quote: doubleQuote(
                    "Tennr is unlike anywhere else I’ve worked. The energy is contagious—it feels like magic to see such intelligent performers push this hard against such a big problem in healthcare."
                  ),
                  image: "/img/khalid-elawad.png",
                  attributedTo: "Khalid Elawad",
                  attributedToTitle: "Product Marketing Manager",
                },
                {
                  quote: doubleQuote("The people are brilliant and personable, creating a collaborative and supportive environment that's addicting to be around. It's incredibly fulfilling to see the tangible impact of our work, with everyone united under a single purpose to solve the problem by any means necessary."),
                  image: "/img/sydney-gil.png",
                  attributedTo: "Sydney Gil",      
                  attributedToTitle: "Engagement Manager",
                },
              ]
          }
          }/>
        </section>
        <section className="careers-press">
          <Heading className="press-heading"
            title="in the news"
            heading="We processed over 10M patients in 2024.  People are noticing."
            position="center"
          />
          <HorizontalMarquee autoscroll={true} autoscrollSpeed={0.1} widthMode="full" gap={26}>
            {pressCards.map((card, i) => (
              <Card key={i} className="careers-press-info-card">
                <img className="logo logo-brown-filter" alt={card.logoAlt} src={card.logoSrc} draggable={false} />
                <p className="shadow-info-body">{card.awardTitle}</p>
              </Card>
            ))}
          </HorizontalMarquee>
        </section>
      </main>
      <SiteFooter taglinePosition="left" bgImage="/img/footer-demo-bg.jpg" bgImageVert="/img/footer-demo-bg-vert.jpg" />
    </>
  );
};
